import React from 'react';
import './Features.css';

const Features = () => {
  const features = [
    {
      icon: '🎓',
      title: 'Active Learning',
      description:
        'Opportunities for growth so that they have a positive outlook throughout their lives. We develop programmes which challenge students to grow physically, emotionally, and intellectually.',
      bgColor: '#ff9a9e',
    },
    {
      icon: '🎵',
      title: 'Music Class',
      description:
        'School organises different cultural activities involving students in dance and musical activities. Students are given the opportunity to participate in different cultural activities.',
      bgColor: '#fbc2eb',
    },
    {
      icon: '🧘',
      title: 'Yoga Class',
      description:
        'We provide yoga classes for our students. In yoga classes, students improve mindfulness, meditation, and concentration. A healthy mind resides in a healthy body.',
      bgColor: '#a18cd1',
    },
    {
      icon: '🛠️',
      title: 'Skill Development',
      description:
        'Our aim is to provide children with a caring and enhanced educational experience. We have tie-ups with industries to arrange seminars on skill development programs.',
      bgColor: '#f6d365',
    },
    {
      icon: '🌿',
      title: 'Eco-Friendly Campus',
      description:
        'We strive to create an eco-friendly campus with green spaces, tree plantations, and awareness programs for a sustainable environment.',
      bgColor: '#81e8d9',
    },
    {
      icon: '🌍',
      title: 'Global Exposure',
      description:
        'We encourage global exposure through collaboration with international institutions and participation in global cultural exchange programs.',
      bgColor: '#ffecd2',
    },
  ];

  return (
    <div className="features-container">
      <h2 className="features-heading">Our Features</h2>
      <div className="features-row">
        {features.map((feature, index) => (
          <div
            key={index}
            className="feature-card"
            style={{ background: feature.bgColor }}
          >
            <div className="feature-icon">{feature.icon}</div>
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-description">{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Features;
